import React, { useCallback, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select, { components } from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar/Topbar";
import { useRef } from "react";
import {
  arrow_icon,
  delete_icon,
  dummyimage,
  toggle_off,
  toggle_on,
} from "../../assets/img";
import CloseIcon from "@mui/icons-material/Close";
import { Radio } from "@mui/material";
import { URLS } from "../../Services/Constant";
import { get, post, put } from "../../Services/ApiHandler";
import { toast } from "react-toastify";

const couponOptions = [
  { value: 1, label: "Influencer" },
  { value: 2, label: "Multiple User" },
];

const OptionWithRadio = (props) => {
  return (
    <components.Option {...props}>
      <div className="d-flex align-items-center gap-2">
        <input type="radio" checked={props.isSelected} onChange={() => null} />
        <label style={{ margin: 0 }}>{props.label}</label>
      </div>
    </components.Option>
  );
};

const LOCATION_TYPES = {
  STATE: 2,
  CITY: 3,
  AREA: 4,
};

const CouponAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formType = location.state?.type;
  const tab = location.state?.tab;
  const datas = location.state?.datas;
  const activeStatus = location.state?.tab;

  const [showReason, setShowReason] = useState(false);
  const admin_details = JSON.parse(localStorage.getItem("admin_details"));

  const isViewMode = formType === "view";
  const [policy, setPolicy] = useState(null);
  const [names, setNames] = useState([]);
  const [isCouponGeneratedOn, setIsCouponGeneratedOn] = useState(true);
  const [isMinPurchaseOn, setIsMinPurchaseOn] = useState(true);
  const [locationList, setLocationsList] = useState({
    states: [],
    cities: [],
    areas: [],
  });
  const [couponPolicy, setCouponPolicy] = useState(false);
  const [selectedServices, setSelectedServices] = useState(null);

  const [image, setImage] = useState(dummyimage);
  const removeImage = () => {
    setImage(null);
  };

  const inputRef = useRef(null);

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    resetField,
    reset,
    clearErrors,
  } = useForm({
    defaultValues: {
      userName: "",
      email: "",
      mobile: "",
      whatsapp: "",
      gender: null,
      nationality: "India",
      state: [],
      city: null,
      area: null,
      googleAddress: "",
      manualAddress: "",
    },
  });
  const getLocationsList = useCallback(async (locationType, parent_id) => {
    try {
      const url = `${URLS.LOCATION}?type=${locationType}${
        parent_id ? "&parent_id=" + parent_id : ""
      }`;
      const res = await get(url);

      if (res?.status === "success") {
        const modifiedList = res.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        switch (locationType) {
          case LOCATION_TYPES.STATE:
            setLocationsList((prev) => ({ ...prev, states: modifiedList }));
            break;
          case LOCATION_TYPES.CITY:
            setLocationsList((prev) => ({ ...prev, cities: modifiedList }));
            break;
          case LOCATION_TYPES.AREA:
            setLocationsList((prev) => ({ ...prev, areas: modifiedList }));
            break;
          default:
            break;
        }
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  }, []);
  const getServicesList = useCallback(async () => {
    try {
      const res = await get(URLS.SERVICESLIST_DROPDOWN);

      if (res?.status === "success") {
        const result = res.data.map((item) => ({
          label: item.display_name,
          value: item.id,
        }));
        setSelectedServices(result);
      }
    } catch (error) {
      console.error("Error fetching services list:", error);
    }
  }, []);
  useEffect(() => {
    isCouponGeneratedOn && setValue("coupongenerated", "  ");
  }, [isCouponGeneratedOn]);
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#F4F4F4",
      borderRadius: 4,
      border: "none",
      padding: 5,
      width: "100%",
      boxShadow: "none",
      minHeight: "initial",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#999999",
    }),
  };
  const { TermsCondition } = watch();
  const onSubmit = async (data) => {
    console.log("Submitted:", data?.state);
    let value = {};
    // setCouponPolicy(names.length == 0);
    // ✅ Handle State IDs
    if (
      Array.isArray(data?.state) &&
      data.state.some((item) => item.label === "All")
    ) {
      value.state_ids = locationList?.states?.map((item) => item.value) || [];
    } else if (data?.state?.length == 0) {
      value.state_ids = locationList?.states?.map((item) => item.value) || [];
    } else {
      value.state_ids = Array.isArray(data?.state)
        ? data.state.map((item) => item.value)
        : [];
    }

    // ✅ Handle City IDs safely
    if (
      Array.isArray(data?.city) &&
      data.city.some((item) => item.label === "All")
    ) {
      value.city = locationList?.cities?.map((item) => item.value) || [];
    } else if (data?.state?.length <= 0 && data?.city?.length == 0) {
      value.city = locationList?.cities?.map((item) => item.value) || [];
    } else {
      value.city = Array.isArray(data?.city)
        ? data.city.map((item) => item.value)
        : "";
    }

    const result = `{${names.map((v) => `conditions:'${v}'`).join(", ")}}`;
    if (names.length <= 0) {
      toast.warn("Terms & Condition is required");
      return;
    }
    if (TermsCondition) {
      toast.warn("Add Terms & Condition");
      return;
    }
    const formData = new FormData();
    formData.append(
      "type",
      data?.CouponType[0]?.value !== undefined
        ? data?.CouponType[0]?.value
        : data?.CouponType?.value
    );
    formData.append("name", data?.CouponName);
    formData.append("code", isCouponGeneratedOn ? 1 : data?.coupongenerated);
    formData.append("amount", data?.Couponamount);
    formData.append(
      "service",
      data?.Servicetype[0]?.value !== undefined
        ? data?.Servicetype[0]?.value
        : data?.Servicetype?.value
    );
    // data?.MinPurchase ? (
    formData.append("min_purchase_amount", data?.MinPurchase || 0);

    formData.append("from_date", data?.startDate);
    formData.append("to_date", data?.endDate);
    formData.append("description", data?.Description);
    formData.append("conditions", JSON.stringify(result));
    formData.append("auto_generate_code", isCouponGeneratedOn);
    data?.image !== datas?.external_image &&
      formData.append("external_image", data?.image);
    data?.Internalimage !== datas?.internal_image &&
      formData.append("internal_image", data?.Internalimage);
    formData.append("state_ids", JSON.stringify(value?.state_ids));
    data?.city
      ? formData.append(
          "city_ids",
          value?.state_ids?.length > 1
            ? JSON.stringify([])
            : JSON.stringify(value?.city)
        )
      : formData.append(
          "city_ids",
          value?.state_ids?.length > 1
            ? JSON.stringify([])
            : JSON.stringify(value?.city)
        );

    try {
      const url = `${URLS.COUPON_ADD}`;
      const res =
        formType === "edit"
          ? await put(`${URLS.COUPON_UPDATEADD}${datas?.id}/edit/`, formData)
          : await post(url, formData);

      if (res?.status === "success") {
        // getList(page);
        navigate("/coupon", { state: { tab: activeStatus } });
        reset();
        console.log("________DASDKA");
      }
    } catch (error) {
      console.error("Error updating coupon status:", error);
    }
    console.log("VALE", value);
    // navigate("/coupon", { state: { activeStatus: 7 } });
  };

  const handleKeyPress = (e) => {
    e.preventDefault();
    console.log("event", names, policy);
    if (policy == null) {
      return null;
    }
    console.log("names", names, e);
    const isDuplicate = names.some(
      (item) => item.toLowerCase() === policy.toLowerCase()
    );

    if (isDuplicate) {
      toast.info("Already added this condition", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }

    if (policy?.trim() !== "") {
      setNames([...names, policy?.trim()]);
      setPolicy("");
      setValue("TermsCondition", "");
    }
  };
  const handleDelete = (item) => {
    setNames(names?.filter((name, i) => i !== item));
    setValue("TermsCondition", "");
  };
  const startDate = watch("startDate");

  const imgRef = useRef(null); // External image input ref
  const InternalimageRef = useRef(null); // Internal image input ref

  const handleImageChange = (e, onChange) => {
    const file = e.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      onChange(file); // set file in RHF
      setValue("imagePreview", url); // preview
      setValue("image", file); // optional if you want to store file itself
    }
  };
  // console.log("datas.city_ids", datas.city_ids);
  const stateValue = watch("state");
  const handleImageChanges = (e, onChange) => {
    const file = e.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      onChange(file); // set file in RHF
      setValue("InternalimagePreview", url);
      setValue("Internalimage", file);
    }
  };
  useEffect(() => {
    locationList?.cities.length == 0 &&
      getLocationsList(
        LOCATION_TYPES.CITY,
        datas && datas.value === 0 ? datas.value : ""
      );
    if (!datas) return;

    setValue(
      "CouponType",
      couponOptions && couponOptions.filter((ele) => ele?.value == datas?.type)
    );
    setValue("CouponName", datas?.name);
    setValue("coupongenerated", datas?.code);
    setValue("Couponamount", datas?.amount);
    setValue(
      "Servicetype",

      selectedServices &&
        selectedServices?.filter((ele) => ele?.value == datas?.service)
    );

    setValue("MinPurchase", datas?.min_purchase_amount);
    setValue("startDate", datas?.from_date);
    setValue("endDate", datas?.to_date);
    setValue("CreatedBy", datas?.created_by);
    // setValue("CreatedBy", datas?.created_by);
    setValue("image", datas?.external_image);
    setValue("imagePreview", datas?.external_image);
    setValue("Internalimage", datas?.internal_image);
    setValue("InternalimagePreview", datas?.internal_image);
    setValue("Description", datas?.description);
    setIsCouponGeneratedOn(false);
    let raw = datas.conditions?.text ? datas.conditions.text : datas.conditions;

    console.log("Before fix:", raw);

    try {
      let values = [];

      if (typeof raw === "string") {
        // Always fix malformed JSON-like strings
        const fixed = raw
          .replace(/(\w+)\s*:/g, '"$1":') // quote keys
          .replace(/'/g, '"'); // replace single quotes

        // 🔍 Extract all occurrences of "conditions":"value"
        const matches = fixed.match(/"conditions"\s*:\s*"([^"]+)"/g);
        if (matches) {
          values = matches.map(
            (m) => m.match(/"conditions"\s*:\s*"([^"]+)"/)[1]
          );
        }
      } else if (
        raw &&
        typeof raw === "object" &&
        typeof raw.conditions === "string"
      ) {
        values = [raw.conditions];
      } else if (
        raw &&
        typeof raw === "object" &&
        Array.isArray(raw.conditions)
      ) {
        values = raw.conditions;
      }

      // ✅ Normalize to consistent structure
      datas.conditions = { conditions: values || [] };

      console.log("After fix:", datas.conditions);
      if (datas.conditions.conditions.length > 0) {
        setNames(datas.conditions.conditions);
      }
    } catch (err) {
      console.error("Failed to parse conditions:", err);
      datas.conditions = { conditions: [] };
    }
  }, [datas, selectedServices]);
  useEffect(() => {
    // if()
    setValue(
      "state",
      datas && datas?.state_ids !== undefined
        ? locationList &&
            locationList.states.filter(
              (item) =>
                datas?.state_ids && datas?.state_ids?.includes(item.value)
            )
        : []
    );
  }, [datas, locationList?.states]);
  useEffect(() => {
    setValue(
      "city",
      datas && datas?.city_ids !== undefined
        ? locationList &&
            locationList.cities.filter(
              (item) => datas?.city_ids && datas?.city_ids?.includes(item.value)
            )
        : []
    );
  }, [datas, locationList.cities]);
  useEffect(() => {
    getLocationsList(LOCATION_TYPES.STATE);
    getServicesList();
  }, [getLocationsList]);
  console.log("locationList", locationList);
  useEffect(() => {
    setValue("CreatedBy", admin_details?.name);
  }, []);
  console.log("Watch", names.length);
  useEffect(() => {
    console.log("Watch2222", stateValue.length);
    if (stateValue.length == 1 && stateValue[0]?.value !== "all") {
      getLocationsList(LOCATION_TYPES.CITY, stateValue[0].value);
    }
  }, [stateValue, datas]);
  return (
    <>
      <Topbar header={"Coupon"} tab={tab} />
      <div className="row mt-5">
        <form
          className="d-flex flex-wrap gap-5"
          onSubmit={handleSubmit(onSubmit)}
        >
          {/* CouponType */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="CouponType"
              rules={{ required: "Coupon Type is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Coupon Type<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    {...field}
                    options={couponOptions}
                    placeholder="Select Coupon"
                    isSearchable
                    onChange={field.onChange}
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode}
                  />
                  {errors.CouponType && (
                    <p style={{ color: "red" }}>{errors.CouponType.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          {/* Coupon Name */}

          <div className="col-md-5">
            <Controller
              control={control}
              name="CouponName"
              rules={{
                required: "Coupon Name is required",
                maxLength: {
                  value: 160,
                  message: "Coupon Name must be 160 characters or less",
                },
              }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Coupon Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Coupon Name"
                    disabled={isViewMode}
                    maxLength={160}
                  />
                  {errors.CouponName && (
                    <p style={{ color: "red" }}>{errors.CouponName.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          {/* Coupon Generated Type */}

          {/* <div className="col-md-5">
            <Controller
              control={control}
              name="coupongenerated"
              rules={{ required: "Coupon Generated is required" }}
              render={({ field }) => (
                <div>
                  <div
                    className="d-flex ac-jb"
                    style={{
                      gap: "10px",
                    }}
                  >
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Coupon Generated Type
                      <span style={{ color: "red" }}>*</span>
                    </label>

                    {formType !== "edit" ? (
                      isCouponGeneratedOn ? (
                        <>
                          <img
                            src={toggle_on}
                            alt="Toggle On"
                            style={{
                              cursor: "pointer",
                              width: "40px",
                              height: "25px",
                            }}
                            onClick={() => {
                              setIsCouponGeneratedOn(false);
                              setValue("coupongenerated", " ");
                            }}
                          />
                        </>
                      ) : (
                        <>
                          <img
                            src={toggle_off}
                            alt="Toggle Off"
                            style={{
                              cursor: "pointer",
                              width: "40px",
                              height: "25px",
                            }}
                            onClick={() => setIsCouponGeneratedOn(true)}
                          />
                        </>
                      )
                    ) : (
                      <></>
                    )}
                  </div>

                  <input
                    {...field}
                    className="input-box"
                    placeholder="coupongenerated"
                    // disabled={}
                    disabled={
                      isCouponGeneratedOn || isViewMode || formType == "edit"
                    }
                  />

                  {errors.coupongenerated && (
                    <p style={{ color: "red" }}>
                      {errors.coupongenerated.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div> */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="coupongenerated"
              rules={{
                required: isCouponGeneratedOn
                  ? false
                  : "Coupon Generated is required",
              }}
              render={({ field }) => (
                <div>
                  <div
                    className="d-flex ac-jb"
                    style={{
                      gap: "10px",
                    }}
                  >
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Coupon Generated Type
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    {formType !== "edit" &&
                      (isCouponGeneratedOn ? (
                        <img
                          src={toggle_on}
                          alt="Toggle On"
                          style={{
                            cursor: "pointer",
                            width: "40px",
                            height: "25px",
                          }}
                          onClick={() => {
                            setIsCouponGeneratedOn(false);
                            setValue("coupongenerated", "");
                          }}
                        />
                      ) : (
                        <img
                          src={toggle_off}
                          alt="Toggle Off"
                          style={{
                            cursor: "pointer",
                            width: "40px",
                            height: "25px",
                          }}
                          onClick={() => {
                            setIsCouponGeneratedOn(true);
                            clearErrors("coupongenerated");
                          }}
                        />
                      ))}
                  </div>

                  <input
                    {...field}
                    className="input-box"
                    placeholder="coupongenerated"
                    disabled={
                      isCouponGeneratedOn || isViewMode || formType === "edit"
                    }
                    onChange={(e) => {
                      field.onChange(e);
                      if (
                        e.target.value.trim() !== "" &&
                        !isCouponGeneratedOn
                      ) {
                        clearErrors("coupongenerated");
                      }
                    }}
                  />

                  {errors.coupongenerated && !isCouponGeneratedOn && (
                    <p style={{ color: "red" }}>
                      {errors.coupongenerated.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>
          {/* Coupon amount */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="Couponamount"
              // rules={{ required: "Coupon amount is required" }}
              // rules={{
              //   required: "Coupon amount is required",
              //   validate: (value) => {
              //     const minPurchaseValue = watch("MinPurchase");
              //     if (
              //       minPurchaseValue &&
              //       Number(minPurchaseValue) <= Number(value)
              //     ) {
              //       return "Min Purchase must be greater than Coupon amount";
              //     }
              //     return true;
              //   },
              // }}
              rules={{
                required: "Coupon amount is required",
                validate: (value) => {
                  // Check for negative coupon amount
                  if (Number(value) < 0) {
                    return "Coupon amount cannot be negative";
                  }

                  const minPurchaseValue = watch("MinPurchase");

                  // Check for negative min purchase
                  // if (minPurchaseValue && ) {
                  //   return "Min Purchase cannot be negative";
                  // }

                  // Check if min purchase is greater than coupon amount
                  if (
                    minPurchaseValue &&
                    Number(minPurchaseValue) <= Number(value) &&
                    Number(value) > 0 &&
                    Number(minPurchaseValue) !== 0
                  ) {
                    return "Min Purchase must be greater than Coupon amount";
                  }

                  return true;
                },
                // validate: (value) => {
                //   // Check for negative coupon amount
                //   if (Number(value) < 0) {
                //     return "Coupon amount cannot be negative";
                //   }

                //   const minPurchaseValue = watch("MinPurchase");

                //   // Check for negative min purchase
                //   if (minPurchaseValue && Number(minPurchaseValue) < 0) {
                //     return "Min Purchase cannot be negative";
                //   }

                //   // Check if min purchase is greater than coupon amount
                //   if (
                //     minPurchaseValue &&
                //     Number(minPurchaseValue) <= Number(value)
                //   ) {
                //     return "Min Purchase must be greater than Coupon amount";
                //   }

                //   return true;
                // },
              }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Coupon amount<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Amount"
                    disabled={isViewMode}
                    type="number"
                  />
                  {errors.Couponamount && (
                    <p style={{ color: "red" }}>
                      {errors.Couponamount.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>
          {/* Service type */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="Servicetype"
              rules={{ required: "Service type is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Service type <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    {...field}
                    options={selectedServices}
                    placeholder="Select Service"
                    isSearchable
                    onChange={field.onChange}
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode}
                  />
                  {errors.Servicetype && (
                    <p style={{ color: "red" }}>{errors.Servicetype.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          {/* State */}
          <div className="col-md-5">
            {/* <Controller
              control={control}
              name="state"
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    State(Optional)
                  </label>
                  <Select
                    {...field}
                    options={[
                      { label: "All", value: "all" },
                      ...locationList?.states,
                    ]}
                    placeholder="Select State"
                    isSearchable
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode}
                    components={{ Option: OptionWithRadio }}
                    isMulti={
                      stateValue && stateValue[0]?.label === "All"
                        ? false
                        : true
                    }
                    onChange={(selected) => {
                      // Handle selection logic
                      console.log("selected[0].value", selected[0].value);
                      let updated = selected;

                      if (!Array.isArray(selected)) {
                        // Single select mode
                        updated =
                          selected?.value === "all" ? [selected] : [selected];
                      } else {
                        const hasAll = selected.some(
                          (item) => item.value === "all"
                        );
                        if (hasAll && selected.length > 1) {
                          // Remove "All" if other states are chosen
                          updated = selected.filter(
                            (item) => item.value !== "all"
                          );
                        }
                      }
                      stateValue &&
                        stateValue.length < 1 &&
                        getLocationsList(
                          LOCATION_TYPES.CITY,
                          selected[0].value
                        );

                      setValue("city", "");
                      field.onChange(updated);
                    }}
                  />
                </div>
              )}
            /> */}
            <Controller
              control={control}
              name="state"
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    State (Optional)
                  </label>
                  <Select
                    {...field}
                    options={[
                      { label: "All", value: "all" },
                      ...locationList?.states,
                    ]}
                    placeholder="Select State"
                    isSearchable
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode}
                    components={{ Option: OptionWithRadio }}
                    isMulti={
                      field?.value &&
                      field.value.length > 0 &&
                      field.value[0]?.value !== "all"
                    }
                    // onChange={(selected) => {
                    //   if (!selected || selected.length === 0) {
                    //     // When cleared
                    //     field.onChange([]);
                    //     return;
                    //   }

                    //   let updated = [];

                    //   if (Array.isArray(selected)) {
                    //     const hasAll = selected.some(
                    //       (item) => item.value === "all"
                    //     );

                    //     if (hasAll) {
                    //       // If "All" is selected among others, keep only "All"
                    //       updated = [{ label: "All", value: "all" }];
                    //     } else {
                    //       // Otherwise, keep selected items excluding "All"
                    //       updated = selected.filter(
                    //         (item) => item.value !== "all"
                    //       );
                    //     }
                    //   } else {
                    //     // Single select (in case isMulti=false)
                    //     updated = [selected];
                    //   }

                    //   // If “All” selected, clear city
                    //   if (updated[0]?.value === "all") {
                    //     setValue("city", "");
                    //   } else {
                    //     stateValue &&
                    //       stateValue.length < 1 &&
                    //       getLocationsList(
                    //         LOCATION_TYPES.CITY,
                    //         updated[0].value
                    //       );
                    //     setValue("city", "");

                    //     // getLocationsList(
                    //     //   LOCATION_TYPES.CITY,
                    //     //   updated[0]?.value
                    //     // );
                    //   }

                    //   field.onChange(updated);
                    // }}
                    onChange={(selected) => {
                      if (!selected || selected.length === 0) {
                        field.onChange([]);
                        return;
                      }

                      let updated = [];

                      if (Array.isArray(selected)) {
                        const hasAll = selected.some(
                          (item) => item.value === "all"
                        );

                        if (hasAll) {
                          updated = [{ label: "All", value: "all" }];
                        } else {
                          updated = selected.filter(
                            (item) => item.value !== "all"
                          );
                        }
                      } else {
                        updated = [selected];
                      }

                      if (updated[0]?.value === "all") {
                        setValue("city", []);
                      } else {
                        if (
                          stateValue &&
                          stateValue.length < 1 &&
                          updated[0]?.value !== "all"
                        ) {
                          getLocationsList(
                            LOCATION_TYPES.CITY,
                            updated[0]?.value
                          );
                        }
                        setValue("city", []);
                      }
                      // setValue("Usertype", []);

                      field.onChange(updated);
                    }}
                  />
                </div>
              )}
            />
          </div>
          {/* City */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="city"
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    City(Optional)
                  </label>
                  <Select
                    {...field}
                    options={[
                      { label: "All", value: "all" },
                      ...locationList?.cities,
                    ]}
                    placeholder="Select City"
                    isSearchable
                    value={field.value}
                    styles={customStyles}
                    components={{ Option: OptionWithRadio }}
                    isMulti={true}
                    isDisabled={
                      (stateValue && stateValue?.length > 1) ||
                      (stateValue && stateValue[0]?.label === "All")
                        ? true
                        : false
                    }
                    onChange={(selected) => {
                      let updated = selected;

                      // Ensure always array (multi-select returns array)
                      if (!Array.isArray(selected)) {
                        updated = selected ? [selected] : [];
                      }

                      const hasAll = updated.some(
                        (item) => item.value === "all"
                      );

                      // ✅ If "All" selected, remove all others
                      if (hasAll && updated.length > 1) {
                        updated = updated.filter(
                          (item) => item.value === "all"
                        );
                      }
                      // ✅ If "All" already selected and user picks another, remove "All"
                      else if (hasAll && updated.length > 1) {
                        updated = updated.filter(
                          (item) => item.value !== "all"
                        );
                      }

                      field.onChange(updated);
                    }}
                  />
                </div>
              )}
            />
          </div>
          {/* Min Purchase */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="MinPurchase"
              render={({ field }) => (
                <div>
                  <div
                    className="d-flex ac-jb"
                    style={{
                      gap: "10px",
                    }}
                  >
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Min Purchase(Optional)
                    </label>
                  </div>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Min Purchase"
                    disabled={!isMinPurchaseOn || isViewMode}
                    type="number"
                    max={9999}
                    onChange={(e) => {
                      const value = e.target.value.slice(0, 4);
                      field.onChange(value ? Number(value) : "");
                    }}
                    onInput={(e) => {
                      // Prevent typing more than 4 digits
                      if (e.target.value.length > 4) {
                        e.target.value = e.target.value.slice(0, 4);
                      }
                    }}
                  />
                </div>
              )}
            />

            {/* <Controller
              control={control}
              name="MinPurchase"
              render={({ field }) => (
                <div>
                  <div
                    className="d-flex ac-jb"
                    style={{
                      gap: "10px",
                    }}
                  >
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Min Purchase(Optional)
                    </label>
                  </div>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Min Purchase"
                    disabled={!isMinPurchaseOn || isViewMode}
                    type="number"
                    max={9999} // Limits to 4 digits
                  />
                </div>
              )}
            /> */}
          </div>

          {/* {start and end date} */}
          <div className="col-md-5 d-flex gap-5 ac-js">
            <div>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Start Date
              </label>
              <Controller
                control={control}
                name="startDate"
                rules={{
                  required: "Start Date is required",
                }}
                render={({ field: { onChange, value } }) => (
                  <div className="relative">
                    <input
                      type="date"
                      value={value}
                      style={{
                        padding: "10px 20px",
                        background: "#F4F4F4",
                        // border: "1.5px solid #adadad",
                        color: "#000",
                        border: "none",
                        borderRadius: 10,
                        width: "90%",
                      }}
                      min={
                        formType === "edit"
                          ? ""
                          : new Date().toISOString().split("T")[0]
                      }
                      onChange={(e) => {
                        onChange(e);
                        setValue("endDate", "");
                      }}
                    />
                  </div>
                )}
              />
              {errors.startDate && (
                <p
                  className="mt-2 text-sm text-red-600"
                  style={{ color: "red" }}
                >
                  {errors.startDate.message}
                </p>
              )}
            </div>

            {/* End Date */}
            <div>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                End Date
              </label>
              <Controller
                control={control}
                name="endDate"
                rules={{
                  required: "End Date is required",
                }}
                render={({ field }) => (
                  <div className="relative">
                    <input
                      type="date"
                      {...field}
                      style={{
                        padding: "10px 20px",
                        background: "#F4F4F4",
                        color: "#000",
                        border: "none",
                        borderRadius: 10,
                        width: "90%",
                      }}
                      // min={}

                      min={
                        startDate || formType === "edit"
                          ? ""
                          : new Date().toISOString().split("T")[0]
                      }
                    />
                  </div>
                )}
              />
              {errors.endDate && (
                <p
                  className="mt-2 text-sm text-red-600"
                  style={{ color: "red" }}
                >
                  {errors.endDate.message}
                </p>
              )}
            </div>
          </div>

          {/* Created By */}

          <div className="col-md-5">
            <Controller
              control={control}
              name="CreatedBy"
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Created By<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Admin"
                    disabled
                  />
                  {errors.CreatedBy && (
                    <p style={{ color: "red" }}>{errors.CreatedBy.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          <div className="col-md-5">
            <p
              className="f3 fs-sm-5 fs-md-6 fs-lg-8 fs-xl-10 fs-xxl-12 mb-3"
              style={{ color: "red" }}
            >
              External Image Max Upload Size : 5MB and Banner Size 1200px 700px*
            </p>
            <Controller
              control={control}
              name="image"
              rules={{ required: "Image is required" }}
              render={({ field: { onChange } }) => (
                <div className="image-wrapper" style={{ position: "relative" }}>
                  {watch("imagePreview") && (
                    <button
                      type="button"
                      className="close_01-btn"
                      style={{
                        position: "absolute",
                        top: "-8px",
                        left: "108px",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "50%",
                        cursor: "pointer",
                        width: "24px",
                        height: "24px",
                        zIndex: 99,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => {
                        setValue("imagePreview", "");
                        setValue("image", "");
                        if (imgRef.current) imgRef.current.value = "";
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </button>
                  )}

                  <button
                    type="button"
                    style={{ border: "none", background: "transparent" }}
                    onClick={() => imgRef.current?.click()}
                  >
                    <img
                      src={watch("imagePreview") || dummyimage}
                      alt="Preview"
                      className="list-img"
                      style={{
                        width: "120px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                    />
                  </button>

                  <input
                    type="file"
                    accept="image/*"
                    className="d-none"
                    ref={imgRef}
                    onChange={(e) => handleImageChange(e, onChange)}
                  />
                </div>
              )}
            />
            {errors.image && (
              <p style={{ color: "red" }}>{errors.image.message}</p>
            )}
          </div>

          <div className="col-md-5">
            <p
              className="f3 fs-sm-5 fs-md-6 fs-lg-8 fs-xl-10 fs-xxl-12 mb-3"
              style={{ color: "red" }}
            >
              Internal Image Max Upload Size : 5MB and Banner Size 1200px 700px*
            </p>
            <Controller
              control={control}
              name="Internalimage"
              rules={{ required: "Image is required" }}
              render={({ field: { onChange } }) => (
                <div className="image-wrapper" style={{ position: "relative" }}>
                  {watch("InternalimagePreview") && (
                    <button
                      type="button"
                      className="close_01-btn"
                      style={{
                        position: "absolute",
                        top: "-8px",
                        left: "108px",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "50%",
                        cursor: "pointer",
                        width: "24px",
                        height: "24px",
                        zIndex: 99,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => {
                        setValue("InternalimagePreview", "");
                        setValue("Internalimage", "");
                        if (InternalimageRef.current)
                          InternalimageRef.current.value = "";
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </button>
                  )}

                  <button
                    type="button"
                    style={{ border: "none", background: "transparent" }}
                    onClick={() => InternalimageRef.current?.click()}
                  >
                    <img
                      src={watch("InternalimagePreview") || dummyimage}
                      alt="Preview"
                      className="list-img"
                      style={{
                        width: "120px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                    />
                  </button>

                  <input
                    type="file"
                    accept="image/*"
                    className="d-none"
                    ref={InternalimageRef}
                    onChange={(e) => handleImageChanges(e, onChange)}
                  />
                </div>
              )}
            />
            {errors.Internalimage && (
              <p style={{ color: "red" }}>{errors.Internalimage.message}</p>
            )}
          </div>

          <div className="col-md-11">
            <Controller
              control={control}
              name="Description"
              rules={{
                required: "Description is required",
              }}
              render={({ field }) => (
                <div style={{ width: "95%" }}>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Description<span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    className="input-box1"
                    {...field}
                    style={{ minHeight: "131px" }}
                    disabled={isViewMode}
                    maxLength={200}
                  />
                </div>
              )}
            />
            {errors.Description && (
              <p
                className="mt-2 text-sm text-red-600 "
                style={{ color: "red", fontSize: 14, fontWeight: 500 }}
              >
                {errors.Description.message}
              </p>
            )}
          </div>

          <div className="col-md-7 mt-5">
            <div className="d-flex ac-jb mb-3">
              <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
                Terms & Condition <span style={{ color: "red" }}>*</span>
              </p>
            </div>
            <div>
              <Controller
                control={control}
                name="TermsCondition"
                rules={{
                  required:
                    names.length > 0 ? false : "Terms & Condition is required",
                }}
                render={({ field }) => (
                  <textarea
                    value={field.value || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      setPolicy(value);
                      field.onChange(value);
                    }}
                    placeholder="Terms & Condition"
                    className="input-border"
                    maxLength={160}
                  />
                )}
              />

              {errors.TermsCondition && (
                <p
                  className="mt-2 text-sm text-red-600 "
                  style={{ color: "red", fontSize: 14, fontWeight: 500 }}
                >
                  {errors.TermsCondition.message}
                </p>
              )}
            </div>
            <div className="d-flex ac-je">
              <button
                onClick={handleKeyPress}
                className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14  "
                style={{ minWidth: "100px" }}
              >
                Add
              </button>
            </div>
            <div>
              {names.length > 0 ? (
                <ul>
                  {names?.map((name, index) => {
                    return (
                      <li className="d-flex as-js gap-3 my-3" key={index}>
                        <img src={arrow_icon} className="back-arrow" alt="" />
                        <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18 col-md-10">
                          {name}
                        </p>

                        <img
                          src={delete_icon}
                          className="edit-btn"
                          onClick={() => {
                            handleDelete(index);
                          }}
                        />
                      </li>
                    );
                  })}
                </ul>
              ) : (
                ""
              )}
            </div>
          </div>

          {formType === "add" && (
            <div
              className="col-lg-11 justify-content-end d-flex "
              style={{ width: "87%" }}
            >
              <button
                onSubmit={handleSubmit(onSubmit)}
                type="submit"
                className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3  "
              >
                Add
              </button>
            </div>
          )}
          {formType === "edit" && (
            <div
              className="col-lg-11 justify-content-end d-flex "
              style={{ width: "87%" }}
            >
              <button
                onSubmit={handleSubmit(onSubmit)}
                type="submit"
                className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3  "
              >
                Submit
              </button>
            </div>
          )}
        </form>
      </div>
    </>
  );
};

export default CouponAdd;
